import React from 'react'
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PricePerSquareFoot = () => {
  const data = [];
  for (let i = 0; i < 100; i++) {

    data.push({
      x: Math.floor(Math.random() * i+20),
      y: Math.floor(Math.random() * i+20),
      z: Math.floor(Math.random() * i+25),
    });
  }
  return (
    <div className='PricePerSquareFoot'>
      <ResponsiveContainer width="100%" height={400}>
        <ScatterChart
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid />
          <XAxis type="number" dataKey="x" name="stature" unit="SF" />
          <YAxis type="number" dataKey="y" unit="$" name="Price / SF" />
          <Tooltip cursor={{ strokeDasharray: '3 3' }} />
          <Scatter name="A Property" data={data} fill="rgb(44, 165, 220)" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  )
}

export default PricePerSquareFoot